//DEV NOTE: Implement Cache functionality
//DEV NOTE 2: Use same architecture for restructuring show and form elements
import { cloneDeep, isObject, flatten } from 'lodash';
import { safeParseISO } from '@/functions/DateHelpers';

export default {
  computed: {
    enumeratedSections() {
      if (!this.sections) return [];
      let arr = this.sections;

      if (!(Array.isArray(arr[0]) && arr.length > 1) || this.$vuetify.breakpoint.xsOnly) {
        arr = flatten(this.sections);

        const DEFAULT_NUM_OF_ROWS_PER_COLUMN = 8;

        //first calculate the layout (how many columns we want in the table)
        if (arr.length >= DEFAULT_NUM_OF_ROWS_PER_COLUMN && this.$vuetify.breakpoint.mdAndUp) {
          // Calculate the split point, ensuring the first half gets the extra element if the length is odd
          const splitIndex = Math.ceil(arr.length / 2);

          const firstHalf = arr.slice(0, splitIndex);
          const secondHalf = arr.slice(splitIndex);

          arr = [firstHalf, secondHalf];
        }
      }

      const array2d = Array.isArray(arr[0]) ? arr : [arr];

      //convert all properties to objects and then restructure them properly
      const result = array2d.map(array1d =>
        this.restructureElementProperties(
          this.convertToObjectArray(array1d)
        )
      );

      return result;
    },
  },
  methods: {
    safeParseISO,
    convertToObjectArray(array) {
      return array.map(element => {
        if (typeof element === 'string') {
          return { key: element };
        }
        return element;
      });
    },
    //-------------RESTRUCTURE--------------
    restructureElementProperties(array1d) {
      const result = array1d.map(element => this.restructureElement(element));

      return result;
    },
    restructureElement(element, value = null) {
      if (!element) return element;

      element['isElementRestructured'] = element.isElementRestructured || false ;
      element = this.setDefaultShowProperty(element);
      element = this.restructureLabelProperties(element);
      element = this.restructureOnlyLabel(element);
      element = this.restructureTransform(element);
      element['isElementRestructured'] = true ;
      return element;
    },
    setDefaultShowProperty(element) {
      //set default value here
      const DEFAULT_SHOW = true;

      const hasShow = Object.hasOwn(element, 'show');
      element['show'] = Boolean(hasShow ? element.show : DEFAULT_SHOW);

      return element;
    },
    restructureLabelProperties(element) {
      const isLabelObject = isObject(element.label || element.text);
      const labelSource = isLabelObject ? element.label || element.text : element;

      //set default values here
      let tempLabel = {
        label: labelSource.label || labelSource.text,
        show: true,
        required: false,
        optional: false,
      }

      // Handle 'required' property
      tempLabel.required = isLabelObject
        ? Boolean(labelSource.required)
        : Boolean(labelSource.labelRequired || tempLabel.required);

      // Handle 'optional' property
      tempLabel.optional = isLabelObject
      ? Boolean(labelSource.optional)
      : Boolean(labelSource.labelOptional || tempLabel.optional);

      // Handle 'show' property
      const hasShowProperty = isLabelObject
        ? 'show' in labelSource
        : 'noLabel' in labelSource;

      tempLabel.show = hasShowProperty
        ? (isLabelObject ? Boolean(labelSource.show) : !labelSource.noLabel)
        : tempLabel.show;

      // Final adjustment for 'show' property
      tempLabel.show = tempLabel.show && element.key !== undefined;

      // Clean up original properties
      ['label', 'labelRequired','labelOptional', 'noLabel', 'text'].forEach(prop => delete element[prop]);

      element['label'] = cloneDeep(tempLabel);

      return element;
    },
    restructureOnlyLabel(element) {
      //set default value here
      let defaultOnlyLabel = false;

      const hasOnlyLabel = Object.hasOwn(element, 'onlyLabel');
      const hasSectionTitle = Object.hasOwn(element, 'sectionTitle');

      //optimization, exit function if we already have onlyLabel property
      if (hasOnlyLabel) return element;

      //if onlyLabel variable is provided, then use it, otherwise use default value (false)
      let providedOnlyLabelValue = hasOnlyLabel ? element?.onlyLabel : defaultOnlyLabel;

      //if we have sectionTitle we assume onlyLabel is true
      if (hasSectionTitle) {
        element['onlyLabel'] = true;
      } else {
        element['onlyLabel'] = providedOnlyLabelValue;
      }

      return element;
    },
    //DEVNOTE: WIP for finding correct transform for each attribute value
    //          - Add more transform types here as needed.
    restructureTransform(element) {
      if (element.transform) return element;

      let transform;
    
      //process of finding transform
      //add more conditions here as needed
      if (element.key == 'status') 
        transform = 'status';
      if (element.value === true || element.value === false)
        transform = 'boolean';
      if (this.hasHtmlTags(element.value))
        transform = 'html';
      if (element.key == 'currentCreatedPhase')
        transform = 'currentPhase';
      if (this.isDateValue(element.value))
        transform = 'datetime.default';

      //when transform is found, assign it to element and return
      if (transform) {
        element['transform'] = transform;
      }

      return element;
    },
    isDateTransform(transform) {
      return transform?.includes('date') || transform?.includes('datetime');
    },
    hasHtmlTags(val) {
      if (typeof val !== 'string') return;
      if (val.length === 0) return;

      return /<\/?[a-z][\s\S]*>/i.test(val);
    },
    isDateValue(val) {
      return ((val === 'createdAt') || (val === 'updatedAt')) || safeParseISO(val);
    },
  },
};